import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  GET_POST,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getPost = (limit = 10) => {
  return (dispatch, getState) => {
    const state = getState().post;

    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/course-community-chat/list-post", {
        search: state.search,
        page: state.page,
        // all: false,
        courseId: state.courseId,
        limit,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });

          dispatch({
            type: GET_POST,
            payload: data?.data?.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};

export const setCourseId = (courseId) => {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_ID, payload: courseId });
  };
};
